import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import image1 from '../assets/image1.png';
import image2 from '../assets/image2.jpg';
import image3 from '../assets/image3.jpg';
import image4 from '../assets/image4.jpg';

const slides = [
  { src: image1, alt: 'Clear Horizons platform preview' },
  { src: image2, alt: 'Accessible workplace collaboration' },
  { src: image3, alt: 'Professional profile and skills showcase' },
  { src: image4, alt: 'Inclusive hiring and career growth' },
];

function Slider() {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((index) => (index + 1) % slides.length);
    }, 4200);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative aspect-[4/3] min-h-[420px] overflow-hidden rounded-[2rem] border border-white/70 bg-slate-100 shadow-2xl shadow-slate-950/10 lg:aspect-[5/4]">
      <AnimatePresence mode="wait">
        <motion.img
          key={slides[currentIndex].src}
          src={slides[currentIndex].src}
          alt={slides[currentIndex].alt}
          className="h-full w-full object-cover"
          initial={{ opacity: 0, scale: 1.03 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.98 }}
          transition={{ duration: 0.7, ease: 'easeOut' }}
        />
      </AnimatePresence>
      <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-slate-950/45 to-transparent p-6">
        <div className="flex gap-2" aria-label="Hero slide progress">
          {slides.map((slide, index) => (
            <button
              key={slide.src}
              type="button"
              aria-label={`Show slide ${index + 1}`}
              onClick={() => setCurrentIndex(index)}
              className={[
                'h-1.5 rounded-full transition-all',
                currentIndex === index ? 'w-9 bg-white' : 'w-3 bg-white/50 hover:bg-white/80',
              ].join(' ')}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Slider;
